/**
 * v-hasPermi 操作权限处理
 */

import store from '@/store'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding

    const isPermission = hasPermission(value)

    if (!isPermission) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}

export function hasPermission(value) {
  const all_permission = '*:*:*'
  const permissions = store.getters.product_and_permission && store.getters.permissions

  if (value && value instanceof Array && value.length > 0) {
    const permissionFlag = value

    return permissions.some(permission => {
      return all_permission === permission || permissionFlag.includes(permission)
    })
  } else {
    console.log(`请设置操作权限标签值`)
    return false
  }
}



// WEBPACK FOOTER //
// ./src/directive/permission/hasPermi.js